import { trigger, state, style, transition, animate } from '@angular/animations';

export const expandCollapse = trigger('expandCollapse', [
  state('collapsed', style({
    height: '0',
    overflow: 'hidden',
    opacity: 0
  })),
  state('expanded', style({
    height: '100%',
    opacity: 1
  })),
  transition('collapsed <=> expanded', [
    animate('3000ms ease-in-out')
  ])
]);
